<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="configuration"
  [callbackFunction]="callbackFunction"
  [(update)]="updateFlag"
  [style]="style"
>
</highcharts-chart>
